(function () {
  'use strict';
  if (window.__LDS_STAINLESS_COVER_REFRESH__) { window.__LDS_STAINLESS_COVER_REFRESH__(); return; }
  window.__LDS_STAINLESS_COVER_REFRESH__ = function () { if (started) bind(document); };

  // Runtime candidate for the stainless collection cover layer. Configuration is
  // intentionally read from each current product wrapper. There is no catalog-wide
  // map, preload, or asset request until the wrapper is near the viewport or hovered.
  var CARD_ATTR = 'data-lds-stainless-cover-card';
  var CONFIG_SELECTOR = 'script[type="application/json"][data-lds-stainless-cover-config]';
  var READY_CLASS = 'lds-stainless-cover-ready';
  var DARK = '#080a0e';
  var states = new Set();
  var stateByCard = new WeakMap();
  var imageCache = new Map();
  var started = false;
  var intersectionObserver = null;
  var bindTimers = new WeakMap();
  var documentObserver = null;
  var activeFlow = null;
  var IMAGE_CACHE_LIMIT = 64;
  var hoverQuery = null;
  var reducedQuery = null;

  function onStainlessCollectionPath() {
    return !!document.body && document.body.classList.contains('hdt-page-type-collection');
  }

  function fineHoverEnabled() {
    return window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isTouchPointer(event) {
    return !!event && (event.pointerType === 'touch' || event.pointerType === 'pen');
  }


  // Only explicitly reviewed recovered-source rasters bypass lossy CDN negotiation.
  async function exactPngImage(url) {
    var response = await fetch(url, {mode: 'cors', credentials: 'omit', headers: {Accept: 'image/png'}});
    if (!response.ok || !/^image\/png(?:;|$)/i.test(response.headers.get('content-type') || '')) throw new Error('Exact PNG asset unavailable');
    var bytes = await response.arrayBuffer(), signature = new Uint8Array(bytes, 0, Math.min(8, bytes.byteLength));
    if (signature.length !== 8 || ![137,80,78,71,13,10,26,10].every(function (v, i) { return signature[i] === v; })) throw new Error('Invalid exact PNG asset');
    var objectUrl = URL.createObjectURL(new Blob([bytes], {type: 'image/png'}));
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () { URL.revokeObjectURL(objectUrl); resolve(image); };
      image.onerror = function () { URL.revokeObjectURL(objectUrl); reject(new Error('Exact PNG decode failed')); };
      image.src = objectUrl;
    });
  }
  function imageFor(url, exactRaster) {
    if (!url) return Promise.reject(new Error('missing cover asset URL'));
    var cacheKey = exactRaster ? 'exact-png:' + url : url;
    if (imageCache.has(cacheKey)) {
      var cached = imageCache.get(cacheKey);
      // Map insertion order gives this small cache an inexpensive LRU policy.
      imageCache.delete(cacheKey);
      imageCache.set(cacheKey, cached);
      return cached;
    }
    var promise = exactRaster ? exactPngImage(url) : new Promise(function (resolve, reject) {
      var image = new Image();
      image.decoding = 'async';
      image.crossOrigin = 'anonymous';
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error('cover asset failed: ' + url)); };
      image.src = url;
    });
    imageCache.set(cacheKey, promise);
    // Do not retain broken CDN URLs for the rest of a long native-pagination
    // session. The identity check avoids deleting a newer retry for the same URL.
    promise.catch(function () {
      if (imageCache.get(cacheKey) === promise) imageCache.delete(cacheKey);
    });
    while (imageCache.size > IMAGE_CACHE_LIMIT) {
      imageCache.delete(imageCache.keys().next().value);
    }
    return promise;
  }

  // Approved white-background masters keep their metal pixels; only the
  // edge-connected white studio is removed before drawing on the dark card.
  var reviewedDarkStudioSources = new Set(["lds-white-master-01d20a03c24b33399da736c8.png","lds-white-master-08c748fb34bf4647d79c1279.png","lds-white-master-0b23ef2c372b8d0192996b23.png","lds-white-master-0dc458af782ff21ebbe36914.png","lds-white-master-0e7d1a0bbd5a1712295428eb.png","lds-white-master-1c44a4f24ee8d8c91daf85c2.png","lds-white-master-2ce895165124253460c98639.png","lds-white-master-2f4d3cdc0cdedf5a907a6dee.png","lds-white-master-34da37e89187bd666401795c.png","lds-white-master-3ad9dcd491322a5614e82423.png","lds-white-master-411efb2abf3947b13b7f164a.png","lds-white-master-44def6699bc3c55c83158a9c.png","lds-white-master-4549a694e65b3a8b9ede81b8.png","lds-white-master-50a24fde96933d0aec993a92.png","lds-white-master-58403f20bfd4ffacf0ad5e33.png","lds-white-master-63ee4cd3bfebaa17a1901427.png","lds-white-master-643b24ca2a79c87252354359.png","lds-white-master-6c81a01a8db784bc806708ce.png","lds-white-master-6f3d728ced468a863418b6e3.png","lds-white-master-74746bff228a648e9f2623e6.png","lds-white-master-79c7c2d6aa925c3867f2347c.png","lds-white-master-7d5db73e6b94cc4fe7ca750e.png","lds-white-master-80d2f3971d5441c8a99f6789.png","lds-white-master-826c910c0c58490d52e54dae.png","lds-white-master-89135e3cac5576387be3e6eb.png","lds-white-master-8c1600e3a0ff338beaa0a6b0.png","lds-white-master-908e5ebf9038661f59d21d8a.png","lds-white-master-90e112e88842b454b0a96dc5.png","lds-white-master-9391288379a682342fd7910f.png","lds-white-master-988043c825859753c4479d33.png","lds-white-master-a27244adf25b54d37cfa4b92.png","lds-white-master-a50deeb7d218c40b06755907.png","lds-white-master-a52013f62330a165622fc6c8.png","lds-white-master-a5bf82fb0b9c06625440bb74.png","lds-white-master-b21f4b0ca118247e9e2dc2a6.png","lds-white-master-c34b040c0f276e45be55ab0d.png","lds-white-master-c588e27c64abbdc9ff1661da.png","lds-white-master-c930bd467dabebd82172ab47.png","lds-white-master-cbd4c6024b89897b97ec8aa3.png","lds-white-master-e6528a638c76bf92003fe66c.png","lds-white-master-eb25b94cb997cfe1481142c4.png","lds-white-master-ee2bf9502c6967f7ee058077.png","lds-white-master-ee5e795cd0558254381805e1.png","lds-white-master-f2cbfe6eae87434f4d08b3ca.png","lds-white-master-fde3679a4d3216e0a5fa97c6.png"]);
  ["lds-contour-master-304aa3dd126b6ac9688c104a.png", "lds-contour-master-ab79dcca783dc25f5cb0ed06.png", "lds-contour-master-6ab34fefd2ed6a8e345488f8.png", "lds-contour-master-a7be80e6516a67ac51c48dda.png", "lds-contour-master-af75a10abd3dcd2c6394daa9.png"].forEach(function (name) { reviewedDarkStudioSources.add(name); });
  var reviewedHorizontalMetalSources = new Set(["lds-contour-master-304aa3dd126b6ac9688c104a.png", "lds-contour-master-ab79dcca783dc25f5cb0ed06.png"]);
  // Full-scope visual review: only confirmed residual source families.
  ["2024-12-15_13.28.38.png", "decoinfabric-ford-led-door-sills-white-ford-mustang-vi-illuminated-led-door-sill-plates-with-mustang-logo-lds-11-37281457340584_95805af6-a37d-47d7-9f8e-672fe1587e94.jpg", "decoinfabric-subaru-led-door-sills-white-front-subaru-forester-iv-led-door-sills-with-forester-logo-lds-1-37387484397736.jpg", "lds-contour-master-08f91faeccfb907054f42c7f.png", "lds-contour-master-0e0a3394d415244db4521d49.png", "lds-contour-master-1d2915367476e60246d4f6aa.png", "lds-contour-master-2ffd101241e3196b70eff55c.png", "lds-contour-master-384b6375b18d627a86f15b5f.png", "lds-contour-master-399c799eca8ffd474970917b.png", "lds-contour-master-5bf7c73acd6d7d9cc4e262f0.png", "lds-contour-master-6f0a22f1ae8db4292845dd71.png", "lds-contour-master-6fa858c73b8facd237ebebc1.png", "lds-contour-master-71b284cdba25594bb29e18e3.png", "lds-contour-master-72551c1c85e1fb79a9b7eced.png", "lds-contour-master-75a59d7910645e9cd5b468c8.png", "lds-contour-master-89456f79898734a26d8d783d.png", "lds-contour-master-8a6552846e91a162c7545ded.png", "lds-contour-master-8db407956df7e5fc7f32cf67.png", "lds-contour-master-925f158e1b2c1adff2c87223.png", "lds-contour-master-9e30cc44c53de53f81f76e95.png", "lds-contour-master-9f4fa386d8ec680ee15e2066.png", "lds-contour-master-c51addc2599ebad933160f5f.png", "lds-contour-master-c826d70975cb7c9f7515ee27.png", "lds-contour-master-eb06f18da853d33f3843efae.png", "lds-contour-master-edfc22cad37b1bfc45333cc6.png", "lds-contour-master-ef9b1ab6c37854b06c6d1e9d.png", "lds-contour-master-f427701d944e65e409001fbf.png", "lds-recovered-master-1ca415d48186b0c7efefd227.png", "lds-recovered-master-9dfba42861b5073b6bb4a5a0.png", "lds-recovered-master-fe5cb469a2ddbe06851c8f23.png", "lds-stainless-cover-source-07f1dddb5175aabdff085e90.png", "lds-stainless-cover-source-19d8b0312b7ee761cbcf923a.png", "lds-stainless-cover-source-21e9f6d60f9d2a9cb1c4fa93.png", "lds-stainless-cover-source-35570287855cba3238010119.png", "lds-stainless-cover-source-79e50e592dd56d80bf70523c.png", "lds-stainless-cover-source-8a8e5b5ce1f5a85f9e8f5bfc.png", "lds-stainless-cover-source-9122d02b1abcff2f4488229c.png", "lds-stainless-cover-source-9a5b6737e8064eaeaccab676.png", "lds-stainless-cover-source-af59f0bdf578770701c449a3.png", "lds-stainless-cover-source-b15d84ba74c44296bb667d30.png", "lds-stainless-cover-source-f0040ed5eeb8a108347e36f0.png", "lds-stainless-prepared-master-050d13ec186b5aa0d90f7b95.png", "lds-stainless-prepared-master-1d6197b8c84fed157baf8f28.png", "lds-stainless-prepared-master-20f7dc482fb24307697d07bf.png", "lds-stainless-prepared-master-21f39a5ec1dd07fc3d227d4e.png", "lds-stainless-prepared-master-2e6cbec3c5d3ff53811fa894.png", "lds-stainless-prepared-master-2ee975742c68b06583188a49.png", "lds-stainless-prepared-master-308d478def0aa6202cbe7174.png", "lds-stainless-prepared-master-3690ad9ea4e1e57a7a16ee20.png", "lds-stainless-prepared-master-386879407258595551590397.png", "lds-stainless-prepared-master-42c71c0cc7c09c4a11df7e80.png", "lds-stainless-prepared-master-4558d14474f7151e9c90bb41.png", "lds-stainless-prepared-master-47d0a2492c3d39b80afd59c8.png", "lds-stainless-prepared-master-47f2a4c425b07d66a5b9b608.png", "lds-stainless-prepared-master-55110bb6c8279d22394ae6c2.png", "lds-stainless-prepared-master-56ddd11fc01e01bc3b035213.png", "lds-stainless-prepared-master-5cf516875111aa8aa764b697.png", "lds-stainless-prepared-master-617da758052e04dbadde0ad2.png", "lds-stainless-prepared-master-72edfe0b0b1cbe5b3189a2a6.png", "lds-stainless-prepared-master-7480210a57e809adf7bf1ccf.png", "lds-stainless-prepared-master-7b3f018b673dc54b3337a1af.png", "lds-stainless-prepared-master-939813358da4b9b4a2b7cec9.png", "lds-stainless-prepared-master-946cb557f85ecd0224f70529.png", "lds-stainless-prepared-master-a5301a8bf737c34734e0fd5f.png", "lds-stainless-prepared-master-a7ec80392e50546405be742c.png", "lds-stainless-prepared-master-a868607be9283f14b2fb3598.png", "lds-stainless-prepared-master-a972ec17575e83d59d695f07.png", "lds-stainless-prepared-master-b6392e31b3be7595b742c656.png", "lds-stainless-prepared-master-bba26211d899c2c17bd0f0dd.png", "lds-stainless-prepared-master-cf2d85aad06fd04629bfeba2.png", "lds-stainless-prepared-master-d376b07f1df8ebebded82dad.png", "lds-stainless-prepared-master-d41945ebd40207ec0d9bb113.png", "lds-stainless-prepared-master-d5f5fe1cf1ad37e9e95df408.png", "lds-stainless-prepared-master-dfc74e0bc0502750c5a34cdf.png", "lds-stainless-prepared-master-e71f375dc7b625a38c75f496.png", "lds-stainless-prepared-master-e7306cb74e80a39fe50909a7.png", "lds-stainless-prepared-master-ea52dee21ce2e28b503ba585.png", "lds-stainless-prepared-master-eda5072209389c3cbe3a539c.png", "lds-stainless-prepared-master-ef8bf8af6a8802d716df9db6.png", "lds-stainless-prepared-master-f5b002e274880f06fdde97f5.png", "lds-stainless-prepared-master-f6d5894db605417c49153e52.png"].forEach(function (name) { reviewedDarkStudioSources.add(name); });
  ["lds-white-master-50a24fde96933d0aec993a92.png","lds-contour-master-0e0a3394d415244db4521d49.png","lds-stainless-prepared-master-e71f375dc7b625a38c75f496.png"].forEach(function(name){ reviewedHorizontalMetalSources.add(name); });
  var fullReviewClips = {"lds-recovered-master-fe5cb469a2ddbe06851c8f23.png": "M 119,630 L 123,615 L 430,452 L 798,260 L 1069,119 L 1150,80 L 1169,76 L 1182,75 L 1190,79 L 1196,85 L 1218,118 L 1224,140 L 1224,152 L 1222,169 L 1214,179 L 1143,221 L 264,710 L 246,720 L 236,725 L 207,725 L 174,719 L 142,703 L 125,671 L 123,660 L 119,631 Z M 206,794 L 211,789 L 218,784 L 221,782 L 365,694 L 545,591 L 1006,335 L 1246,205 L 1261,197 L 1306,178 L 1313,178 L 1319,180 L 1334,197 L 1362,237 L 1362,260 L 1361,267 L 1357,285 L 1352,291 L 1349,294 L 1195,396 L 416,853 L 330,894 L 323,896 L 309,898 L 308,898 L 286,893 L 264,884 L 262,883 L 254,877 L 237,861 L 207,808 L 206,795 Z", "lds-recovered-master-9dfba42861b5073b6bb4a5a0.png": "M 684,1064 L 720,1048 L 2172,516 L 2180,516 L 2204,540 L 2224,564 L 2236,580 L 2252,604 L 2260,620 L 2264,640 L 2264,644 L 2260,656 L 2256,660 L 2232,672 L 2064,740 L 1964,780 L 1752,864 L 1508,960 L 1148,1100 L 972,1168 L 920,1188 L 888,1200 L 876,1204 L 848,1200 L 828,1184 L 796,1172 L 716,1108 L 684,1072 Z M 276,1504 L 324,1480 L 344,1472 L 2648,560 L 2660,556 L 2664,556 L 2688,576 L 2724,612 L 2748,640 L 2760,656 L 2772,680 L 2772,696 L 2760,708 L 2744,716 L 2708,732 L 2616,772 L 1692,1168 L 1224,1368 L 876,1516 L 668,1604 L 516,1668 L 496,1676 L 484,1680 L 456,1684 L 436,1684 L 424,1680 L 400,1668 L 352,1620 L 336,1600 L 324,1584 L 316,1572 L 276,1508 Z", "lds-white-master-80d2f3971d5441c8a99f6789.png": "M 80,273 L 88,265 L 104,256 L 401,168 L 544,128 L 608,112 L 619,112 L 622,113 L 623,114 L 647,160 L 647,175 L 638,181 L 636,182 L 617,189 L 477,238 L 254,316 L 199,335 L 173,343 L 130,343 L 121,335 L 105,319 L 96,309 L 81,287 L 80,285 Z M 112,379 L 120,368 L 129,360 L 152,342 L 160,339 L 640,171 L 644,170 L 645,170 L 687,177 L 695,184 L 711,208 L 717,224 L 717,247 L 711,254 L 700,263 L 627,295 L 301,423 L 237,447 L 197,461 L 194,462 L 192,462 L 184,460 L 170,455 L 160,451 L 136,423 L 120,398 L 112,383 Z"};
  function darkStudioSource(image, url) {
    if (fullReviewClips[url.split("/").pop().split("?")[0]]) return image;
    if (!url || !reviewedDarkStudioSources.has(url.split('/').pop().split('?')[0])) return image;
    if (image.__ldsDarkStudioSource) return image.__ldsDarkStudioSource;
    var size = naturalSize(image);
    var canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    var context = canvas.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0);
    // Reviewed non-product UI fragments, outside every plate and emission.
    var sourceName = url.split('/').pop().split('?')[0];
    if (sourceName === 'lds-stainless-prepared-master-3690ad9ea4e1e57a7a16ee20.png') context.clearRect(0, Math.floor(canvas.height * 612 / 636), canvas.width, canvas.height);
    if (sourceName === 'lds-white-master-e6528a638c76bf92003fe66c.png') context.clearRect(0, 0, canvas.width, Math.floor(canvas.height * 100 / 514));
    if (sourceName === 'lds-white-master-643b24ca2a79c87252354359.png') context.clearRect(0, Math.floor(canvas.height * 600 / 711), canvas.width, canvas.height);
    if (sourceName === 'lds-contour-master-ef9b1ab6c37854b06c6d1e9d.png') { context.clearRect(0,0,canvas.width,Math.ceil(canvas.height*5/319)); context.clearRect(0,Math.ceil(canvas.height*318/319),canvas.width,canvas.height); context.clearRect(0,canvas.height*310/319,canvas.width*170/640,canvas.height); context.clearRect(canvas.width*460/640,canvas.height*310/319,canvas.width,canvas.height); }
    if (sourceName === 'lds-contour-master-75a59d7910645e9cd5b468c8.png' || sourceName === 'lds-contour-master-5bf7c73acd6d7d9cc4e262f0.png') context.clearRect(0,Math.floor(canvas.height*.88),canvas.width,canvas.height);
    if (sourceName === 'lds-white-master-3ad9dcd491322a5614e82423.png') context.clearRect(0,Math.floor(canvas.height*760/883),canvas.width,canvas.height);
    var frame = context.getImageData(0, 0, canvas.width, canvas.height);
    var data = frame.data;
    var width = canvas.width, height = canvas.height, length = width * height;
    // These two reviewed horizontal Dodge photos have bright metal reflections
    // touching the plate edge. Preserve the span between the real dark edges
    // on each source row; otherwise a white-background flood would eat metal.
    var rowSpans = null;
    if (reviewedHorizontalMetalSources.has(url.split('/').pop().split('?')[0])) {
      rowSpans = new Int32Array(height * 2);
      rowSpans.fill(-1);
      for (var sy = 0; sy < height; sy++) {
        for (var sx = 0; sx < width; sx++) {
          var offset = (sy * width + sx) * 4;
          if (data[offset + 3] && Math.min(data[offset], data[offset + 1], data[offset + 2]) < 200) {
            if (rowSpans[sy * 2] < 0) rowSpans[sy * 2] = sx;
            rowSpans[sy * 2 + 1] = sx;
          }
        }
      }
    }
    function white(index) {
      if (rowSpans) {
        var row = Math.floor(index / width), col = index % width;
        if (rowSpans[row * 2] >= 0 && col >= rowSpans[row * 2] && col <= rowSpans[row * 2 + 1]) return false;
      }
      var offset = index * 4;
      var red = data[offset], green = data[offset + 1], blue = data[offset + 2];
      return data[offset + 3] > 0 && Math.min(red, green, blue) >= (/lds-stainless-prepared-master-(2ee975742c68b06583188a49|21f39a5ec1dd07fc3d227d4e)/.test(url) ? 218 : 238) &&
        Math.max(red, green, blue) - Math.min(red, green, blue) <= 24;
    }
    var corners = [0, width - 1, (height - 1) * width, length - 1];
    var whiteCorners = corners.filter(function (index) { return white(index); }).length;
    var edgeSamples = 0, whiteEdgeSamples = 0;
    function sample(index) { edgeSamples++; if (white(index)) whiteEdgeSamples++; }
    for (var sx = 0; sx < width; sx += Math.max(1, Math.ceil(width / 32))) {
      sample(sx); sample((height - 1) * width + sx);
    }
    for (var sy = 0; sy < height; sy += Math.max(1, Math.ceil(height / 32))) {
      sample(sy * width); sample(sy * width + width - 1);
    }
    if (sourceName !== 'lds-contour-master-ef9b1ab6c37854b06c6d1e9d.png' && whiteCorners < 3 && whiteEdgeSamples / edgeSamples < 0.6) {
      image.__ldsDarkStudioSource = image;
      return image;
    }
    var seen = new Uint8Array(length), queue = new Int32Array(length), head = 0, tail = 0;
    function enqueue(index) {
      if (seen[index]) return;
      seen[index] = 1;
      if (white(index)) queue[tail++] = index;
    }
    for (var x = 0; x < width; x++) { enqueue(x); enqueue((height - 1) * width + x); }
    for (var y = 0; y < height; y++) { enqueue(y * width); enqueue(y * width + width - 1); }
    while (head < tail) {
      var index = queue[head++], px = index % width;
      data[index * 4 + 3] = 0;
      if (px > 0) enqueue(index - 1);
      if (px + 1 < width) enqueue(index + 1);
      if (index >= width) enqueue(index - width);
      if (index + width < length) enqueue(index + width);
    }
    if (tail < length * 0.05) {
      image.__ldsDarkStudioSource = image;
      return image;
    }
    context.putImageData(frame, 0, 0);
    image.__ldsDarkStudioSource = canvas;
    return canvas;
  }

  function containTransform(sourceSize, width, height) {
    var sourceWidth = Number(sourceSize[0]);
    var sourceHeight = Number(sourceSize[1]);
    var scale = Math.min(width / sourceWidth, height / sourceHeight);
    var drawnWidth = sourceWidth * scale;
    var drawnHeight = sourceHeight * scale;
    return {
      scale: scale,
      x: (width - drawnWidth) / 2,
      y: (height - drawnHeight) / 2,
      width: drawnWidth,
      height: drawnHeight
    };
  }

  function clearCanvas(context, width, height) {
    context.globalCompositeOperation = 'source-over';
    context.clearRect(0, 0, width, height);
  }

  function naturalSize(image) {
    return {
      width: Number(image.naturalWidth || image.width || 0),
      height: Number(image.naturalHeight || image.height || 0)
    };
  }

  function positiveNumber(value) {
    return Number.isFinite(Number(value)) && Number(value) > 0;
  }

  function finiteNumber(value) {
    return Number.isFinite(Number(value));
  }

  function validSize(value) {
    return Array.isArray(value) && value.length >= 2 &&
      positiveNumber(value[0]) && positiveNumber(value[1]);
  }

  function validRect(value) {
    return Array.isArray(value) && value.length >= 4 &&
      finiteNumber(value[0]) && finiteNumber(value[1]) &&
      positiveNumber(value[2]) && positiveNumber(value[3]);
  }

  function originalCrop(config) {
    var sourceSize = config.sourceSize;
    var crop = config.sourceCrop || [0, 0, sourceSize[0], sourceSize[1]];
    return [Number(crop[0]), Number(crop[1]), Number(crop[2]), Number(crop[3])];
  }

  function actualCrop(state) {
    var source = naturalSize(state.sourceImage);
    var sourceSize = state.config.sourceSize;
    var crop = originalCrop(state.config);
    var scaleX = source.width / Number(sourceSize[0]);
    var scaleY = source.height / Number(sourceSize[1]);
    return {
      original: crop,
      scaleX: scaleX,
      scaleY: scaleY,
      value: [crop[0] * scaleX, crop[1] * scaleY, crop[2] * scaleX, crop[3] * scaleY]
    };
  }

  function foldMaskLuminanceIntoAlpha(state) {
    // Approved masks carry source-derived shade in RGB as well as coverage in A.
    // Legacy masks fold max-RGB into alpha. New source-luma masks divide their
    // emission intensity by the source brightness to recover coverage; the
    // source itself supplies the soft halo falloff during multiply compositing.
    var imageData;
    try {
      imageData = state.maskContext.getImageData(0, 0, state.pixelWidth, state.pixelHeight);
    } catch (error) {
      throw new Error('same-origin mask readback unavailable: ' + error.message);
    }
    var pixels = imageData.data;
    var sourcePixels = state.config.sourceLumaTint ? state.baseContext.getImageData(0, 0, state.pixelWidth, state.pixelHeight).data : null;
    for (var i = 0; i < pixels.length; i += 4) {
      var shade = Math.max(pixels[i], pixels[i + 1], pixels[i + 2]);
      pixels[i + 3] = state.config.sourceLumaTint ?
        Math.min(255, Math.round(pixels[i + 3] * shade / Math.max(1, sourcePixels[i], sourcePixels[i + 1], sourcePixels[i + 2]))) :
        Math.round(pixels[i + 3] * shade / 255);
      pixels[i] = 255;
      pixels[i + 1] = 255;
      pixels[i + 2] = 255;
    }
    state.maskContext.putImageData(imageData, 0, 0);
  }

  function makeTintLayer(state, tint) {
    var width = state.pixelWidth;
    var height = state.pixelHeight;
    var context = state.tintContext;
    clearCanvas(context, width, height);
    var sourceLuma = !!state.config.sourceLumaTint && typeof tint !== 'string';
    context.drawImage(sourceLuma ? state.baseCanvas : state.maskCanvas, 0, 0, width, height);
    context.globalCompositeOperation = sourceLuma ? 'multiply' : 'source-in';
    if (typeof tint === 'string') {
      context.fillStyle = tint;
    } else {
      // Native FLOW is a moving spatial rainbow inside the exact approved mask.
      var phase = (Number(tint || 0) * 0.00008) % 1;
      var shift = (phase * width * 2) % (width * 2);
      var gradient = context.createLinearGradient(-width + shift, 0, width + shift, height * 0.08);
      var hue = phase * 360;
      gradient.addColorStop(0, 'hsl(' + ((hue + 0) % 360).toFixed(1) + ' 100% 60%)');
      gradient.addColorStop(0.25, 'hsl(' + ((hue + 72) % 360).toFixed(1) + ' 100% 60%)');
      gradient.addColorStop(0.5, 'hsl(' + ((hue + 144) % 360).toFixed(1) + ' 100% 60%)');
      gradient.addColorStop(0.75, 'hsl(' + ((hue + 216) % 360).toFixed(1) + ' 100% 60%)');
      gradient.addColorStop(1, 'hsl(' + ((hue + 288) % 360).toFixed(1) + ' 100% 60%)');
      context.fillStyle = gradient;
    }
    context.fillRect(0, 0, width, height);
    if (sourceLuma) {
      context.globalCompositeOperation = 'destination-in';
      context.drawImage(state.maskCanvas, 0, 0, width, height);
    }
    context.globalCompositeOperation = 'source-over';
  }

  function drawBase(state) {
    if (!state.ready || !state.pixelWidth || !state.pixelHeight) return;
    var context = state.context;
    clearCanvas(context, state.pixelWidth, state.pixelHeight);
    context.drawImage(state.baseCanvas, 0, 0, state.pixelWidth, state.pixelHeight);
  }

  function drawWhite(state) {
    drawBase(state);
  }

  function drawFlow(state, timestamp) {
    if (!state.ready || !state.maskImage) return;
    drawBase(state);
    makeTintLayer(state, Number(timestamp || 0));
    if (state.config.artworkCoverage) {
      // The white master already includes subpixel artwork coverage. Replace
      // that emission instead of blending a second layer over its white edge.
      var frame = state.baseContext.getImageData(0, 0, state.pixelWidth, state.pixelHeight);
      var tint = state.tintContext.getImageData(0, 0, state.pixelWidth, state.pixelHeight).data;
      for (var p = 0; p < frame.data.length; p += 4) {
        var coverage = tint[p + 3] / 255;
        for (var k = 0; k < 3; k++) frame.data[p + k] = Math.round(frame.data[p + k] + (tint[p + k] - 255) * coverage);
      }
      state.context.putImageData(frame, 0, 0);
    } else {
      state.context.drawImage(state.tintCanvas, 0, 0, state.pixelWidth, state.pixelHeight);
    }
  }

  function greyReviewedSteelBody(state) {
    // Only previously reviewed Stainless masters; approved emission and its
    // antialiased edges are immutable. Never infer a missing artwork mask.
    var name = (state.config.sourceUrl || '').split('/').pop().split('?')[0];
    if (!reviewedDarkStudioSources.has(name) || !state.maskImage) return;
    var frame = state.baseContext.getImageData(0, 0, state.pixelWidth, state.pixelHeight);
    var mask = state.maskContext.getImageData(0, 0, state.pixelWidth, state.pixelHeight).data;
    var pixels = frame.data;
    for (var p = 0; p < pixels.length; p += 4) {
      var coverage = mask[p + 3] / 255;
      var horizontalMetal = reviewedHorizontalMetalSources.has(name);
      if (coverage === 1 || (coverage > 0 && !horizontalMetal)) continue;
      var low = Math.min(pixels[p], pixels[p + 1], pixels[p + 2]);
      var high = Math.max(pixels[p], pixels[p + 1], pixels[p + 2]);
      // Preserve dark contours and saturated fixed-color details. Compress
      // only the light metal range, retaining surface shading and geometry.
      if (low <= 100 || (high - low > 45 && !reviewedHorizontalMetalSources.has(name))) continue;
      var luma = pixels[p] * 0.2126 + pixels[p + 1] * 0.7152 + pixels[p + 2] * 0.0722;
      var grey = Math.round(100 + (luma - 100) * 0.42);
      if (horizontalMetal && coverage > 0) {
        // Keep the existing white artwork coverage over the toned metal.
        // Fully covered lettering is immutable; partial edge coverage remains.
        for (var channel = 0; channel < 3; channel++) {
          pixels[p + channel] = Math.round(grey * (1 - coverage) + pixels[p + channel] * coverage);
        }
      } else {
        pixels[p] = pixels[p + 1] = pixels[p + 2] = grey;
      }
    }
    state.baseContext.putImageData(frame, 0, 0);
  }

  function prepareCanvases(state) {
    if (state.removed || !state.card.isConnected || !state.sourceImage ||
        (state.requiresMask && !state.maskImage)) return false;
    var rect = state.link.getBoundingClientRect();
    var width = Math.round(rect.width);
    var height = Math.round(rect.height);
    if (!width || !height) return false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var pixelWidth = Math.max(1, Math.round(width * dpr));
    var pixelHeight = Math.max(1, Math.round(height * dpr));
    state.width = width;
    state.height = height;
    state.dpr = dpr;
    state.pixelWidth = pixelWidth;
    state.pixelHeight = pixelHeight;
    state.canvas.width = pixelWidth;
    state.canvas.height = pixelHeight;
    state.baseCanvas.width = pixelWidth;
    state.baseCanvas.height = pixelHeight;
    state.maskCanvas.width = pixelWidth;
    state.maskCanvas.height = pixelHeight;
    state.tintCanvas.width = pixelWidth;
    state.tintCanvas.height = pixelHeight;

    // Shopify serves sourceUrl at width=640. Convert the original sourceCrop to
    // the image's actual natural dimensions before drawing or placing the mask.
    var crop = actualCrop(state);
    state.crop = crop;
    state.transform = containTransform([crop.value[2], crop.value[3]], width, height);

    var sourceContext = state.baseContext;
    clearCanvas(sourceContext, pixelWidth, pixelHeight);
    sourceContext.fillStyle = DARK;
    sourceContext.fillRect(0, 0, pixelWidth, pixelHeight);
    var transform = state.transform;
    sourceContext.save();
    if (state.config.sourceClip) {
      // Reviewed native product silhouette only; retain the source pixels inside
      // it while the collection canvas supplies the dark studio surround.
      sourceContext.setTransform(transform.scale * crop.scaleX * dpr, 0, 0,
        transform.scale * crop.scaleY * dpr,
        (transform.x - crop.value[0] * transform.scale) * dpr,
        (transform.y - crop.value[1] * transform.scale) * dpr);
      sourceContext.clip(new Path2D(state.config.sourceClip));
      sourceContext.setTransform(1, 0, 0, 1, 0, 0);
    }
    sourceContext.drawImage(
      state.sourceImage,
      crop.value[0], crop.value[1], crop.value[2], crop.value[3],
      transform.x * dpr,
      transform.y * dpr,
      transform.width * dpr,
      transform.height * dpr
    );

    sourceContext.restore();

    var maskContext = state.maskContext;
    clearCanvas(maskContext, pixelWidth, pixelHeight);
    if (state.maskImage) {
      var bbox = state.config.bbox || [0, 0, state.config.maskSize[0], state.config.maskSize[1]];
      var maskNatural = naturalSize(state.maskImage);
      var maskSize = [Number(state.config.maskSize[0]), Number(state.config.maskSize[1])];
      var maskScaleX = maskNatural.width / maskSize[0];
      var maskScaleY = maskNatural.height / maskSize[1];
      var sourceX = Number(bbox[0]) * crop.scaleX;
      var sourceY = Number(bbox[1]) * crop.scaleY;
      var sourceWidth = maskSize[0] * crop.scaleX;
      var sourceHeight = maskSize[1] * crop.scaleY;
      maskContext.save();
      if (state.config.sourceClip) {
        maskContext.setTransform(transform.scale * crop.scaleX * dpr, 0, 0,
          transform.scale * crop.scaleY * dpr,
          (transform.x - crop.value[0] * transform.scale) * dpr,
          (transform.y - crop.value[1] * transform.scale) * dpr);
        maskContext.clip(new Path2D(state.config.sourceClip));
        maskContext.setTransform(1, 0, 0, 1, 0, 0);
      }
      maskContext.drawImage(
        state.maskImage,
        (transform.x + (sourceX - crop.value[0]) * transform.scale) * dpr,
        (transform.y + (sourceY - crop.value[1]) * transform.scale) * dpr,
        (sourceWidth * transform.scale) * dpr,
        (sourceHeight * transform.scale) * dpr
      );
      maskContext.restore();
      // Keep the natural mask ratio explicit even if an asset CDN rounds one
      // dimension by a pixel; the configured maskSize remains original coords.
      state.maskNaturalScale = [maskScaleX, maskScaleY];
      foldMaskLuminanceIntoAlpha(state);
    }

    // White is source-derived: the approved mask supplies neutral colour while
    // retaining source luma/falloff and leaving the rest of the native image alone.
    if (state.config.neutralizeEmission && state.maskImage) {
      // Opt-in only for reviewed colored-emission sources. The mask defines
      // permission to neutralize: body and fixed logo colors outside it stay
      // byte-identical. Max-channel preserves the source's LED intensity and
      // halo falloff rather than painting an opaque white shape.
      var sourcePixels = sourceContext.getImageData(0, 0, pixelWidth, pixelHeight);
      var emissionPixels = maskContext.getImageData(0, 0, pixelWidth, pixelHeight).data;
      var values = sourcePixels.data;
      for (var p = 0; p < values.length; p += 4) {
        if (emissionPixels[p + 3] === 0) continue;
        var intensity = Math.max(values[p], values[p + 1], values[p + 2]);
        var coverage = emissionPixels[p + 3] / 255;
        values[p] += (intensity - values[p]) * coverage;
        values[p + 1] += (intensity - values[p + 1]) * coverage;
        values[p + 2] += (intensity - values[p + 2]) * coverage;
      }
      sourceContext.putImageData(sourcePixels, 0, 0);
    } else if (state.config.whiteMaskOverlay && state.maskImage && !state.config.sourceLumaTint && !state.config.artworkCoverage) {
      makeTintLayer(state, '#ffffff');
      sourceContext.drawImage(state.tintCanvas, 0, 0, pixelWidth, pixelHeight);
    }
    greyReviewedSteelBody(state);
    state.ready = true;
    drawWhite(state);
    return true;
  }

  function stopFlow(state) {
    state.active = false;
    if (activeFlow === state) activeFlow = null;
    if (state.raf) {
      window.cancelAnimationFrame(state.raf);
      state.raf = 0;
    }
    if (state.ready) drawWhite(state);
  }

  function frame(state, timestamp) {
    state.raf = 0;
    if (!state.active || activeFlow !== state || !state.ready || !state.hovered ||
        !fineHoverEnabled() || !state.card.isConnected ||
        document.visibilityState === 'hidden') {
      stopFlow(state);
      return;
    }
    drawFlow(state, timestamp);
    state.frames += 1;
    state.raf = window.requestAnimationFrame(function (nextTimestamp) {
      frame(state, nextTimestamp);
    });
  }

  function startFlow(state) {
    if (state.removed || !state.config.flow || !state.ready || !state.maskImage ||
        !fineHoverEnabled() || !state.hovered || document.visibilityState === 'hidden') return;
    if (activeFlow && activeFlow !== state) {
      // A pointer can cross cards before the browser delivers the old leave
      // event. Clear the old intent as well as its RAF so a late asset promise
      // cannot reclaim the single animation slot.
      activeFlow.hovered = false;
      stopFlow(activeFlow);
    }
    activeFlow = state;
    state.active = true;
    if (!state.raf) state.raf = window.requestAnimationFrame(function (timestamp) {
      frame(state, timestamp);
    });
  }

  function loadState(state) {
    if (state.removed) return Promise.resolve(state);
    if (state.loadPromise) return state.loadPromise;
    state.sourceRequested = true;
    state.maskRequested = !!state.config.maskUrl;
    var maskPromise = state.config.maskUrl ? imageFor(state.config.maskUrl, state.config.exactRaster) : Promise.resolve(null);
    state.loadPromise = Promise.all([imageFor(state.config.sourceUrl, state.config.exactRaster), maskPromise]).then(function (images) {
      if (state.removed || !state.card.isConnected) return state;
      state.sourceImage = darkStudioSource(images[0], state.config.sourceUrl);
      state.maskImage = images[1];
      if (state.removed || !state.card.isConnected) return state;
      if (!prepareCanvases(state)) return state;
      if (state.removed || !state.card.isConnected) return state;
      state.card.classList.add(READY_CLASS);
      // A hover can begin before either asset finishes. Preserve that intent and
      // start exactly when the ready canvas exists, if the pointer is still there.
      if (state.hovered) startFlow(state);
      return state;
    }).catch(function (error) {
      failState(state, error);
      throw error;
    });
    return state.loadPromise;
  }

  function onPointerEnter(state, event) {
    if (isTouchPointer(event) || !fineHoverEnabled()) {
      state.hovered = false;
      stopFlow(state);
      return;
    }
    state.hovered = true;
    state.visible = true;
    loadState(state).then(function () {
      if (state.hovered) startFlow(state);
    }).catch(function () {});
  }

  function onPointerLeave(state) {
    state.hovered = false;
    stopFlow(state);
  }

  function removeState(state) {
    if (state.removed) return;
    state.removed = true;
    stopFlow(state);
    state.hovered = false;
    state.card.removeEventListener('pointerenter', state.onEnter);
    state.card.removeEventListener('pointerleave', state.onLeave);
    state.card.classList.remove(READY_CLASS);
    state.card.removeAttribute(CARD_ATTR);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    if (intersectionObserver) intersectionObserver.unobserve(state.media);
    if (state.canvas.parentNode) state.canvas.parentNode.removeChild(state.canvas);
    // Release decoded image references and backing-store memory when native
    // pagination/filtering removes a card. The pending image promise may still
    // settle, so its completion path also checks this tombstone.
    state.canvas.width = 0;
    state.canvas.height = 0;
    state.baseCanvas.width = 0;
    state.baseCanvas.height = 0;
    state.maskCanvas.width = 0;
    state.maskCanvas.height = 0;
    state.tintCanvas.width = 0;
    state.tintCanvas.height = 0;
    state.sourceImage = null;
    state.maskImage = null;
    state.crop = null;
    state.transform = null;
    stateByCard.delete(state.card);
    states.delete(state);
  }

  function failState(state, error) {
    removeState(state);
    if (window.console && console.warn) console.warn('[lds-cover] preserving native card media', error);
  }

  function makeState(wrapper, card, media, link, config, configNode) {
    var canvas = link.querySelector('[data-lds-stainless-cover-canvas]');
    if (!canvas) canvas = document.createElement('canvas');
    canvas.className = 'lds-stainless-cover-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.setAttribute('role', 'presentation');
    canvas.setAttribute('data-lds-stainless-cover-canvas', '');
    canvas.width = 0;
    canvas.height = 0;
    if (!canvas.parentNode) link.appendChild(canvas);
    card.classList.remove(READY_CLASS);
    var requiresMask = !!config.maskUrl && (!!config.neutralizeEmission || config.whiteMaskOverlay !== false || !!config.flow);
    var state = {
      wrapper: wrapper,
      card: card,
      media: media,
      link: link,
      config: config,
      configNode: configNode,
      configText: configNode.textContent || '',
      requiresMask: requiresMask,
      canvas: canvas,
      context: canvas.getContext('2d'),
      baseCanvas: document.createElement('canvas'),
      maskCanvas: document.createElement('canvas'),
      tintCanvas: document.createElement('canvas'),
      sourceImage: null,
      maskImage: null,
      baseContext: null,
      maskContext: null,
      tintContext: null,
      loadPromise: null,
      sourceRequested: false,
      maskRequested: false,
      removed: false,
      ready: false,
      active: false,
      hovered: false,
      visible: false,
      raf: 0,
      frames: 0,
      width: 0,
      height: 0,
      pixelWidth: 0,
      pixelHeight: 0,
      transform: null,
      crop: null,
      resizeObserver: null,
      onEnter: null,
      onLeave: null
    };
    state.baseContext = state.baseCanvas.getContext('2d');
    state.maskContext = state.maskCanvas.getContext('2d');
    state.tintContext = state.tintCanvas.getContext('2d');
    state.onEnter = function (event) { onPointerEnter(state, event); };
    state.onLeave = function () { onPointerLeave(state); };
    card.setAttribute(CARD_ATTR, '');
    card.addEventListener('pointerenter', state.onEnter);
    card.addEventListener('pointerleave', state.onLeave);
    if (typeof ResizeObserver === 'function') {
      state.resizeObserver = new ResizeObserver(function () {
        if (!state.sourceImage || (state.requiresMask && !state.maskImage)) return;
        try {
          if (prepareCanvases(state)) {
            card.classList.add(READY_CLASS);
            if (state.hovered) startFlow(state);
          }
        } catch (error) {
          failState(state, error);
        }
      });
      state.resizeObserver.observe(link);
    }
    if (intersectionObserver) intersectionObserver.observe(media);
    states.add(state);
    stateByCard.set(card, state);
    return state;
  }

  function ownerForConfig(node) {
    if (!node || !node.closest) return null;
    return node.closest('hdt-card-product[data-lds-product-id]') || node.closest('[data-product-id]');
  }

  function configuredWrappers(root) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll(CONFIG_SELECTOR));
    var wrappers = [];
    nodes.forEach(function (node) {
      var wrapper = ownerForConfig(node);
      if (wrapper && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    });
    return wrappers;
  }

  function cardFor(wrapper) {
    var card = wrapper.matches && wrapper.matches('hdt-card-product') ? wrapper : wrapper.querySelector('hdt-card-product');
    var scope = card || wrapper;
    var media = scope.querySelector('.hdt-card-product__media');
    var link = scope.querySelector('.hdt-card-product__media-wrapp');
    if (!card || !media || !link) return null;
    return { card: card, media: media, link: link };
  }

  function configFor(wrapper) {
    var node = wrapper.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try {
      var config = JSON.parse(node.textContent || '{}');
      var wrapperId = String(wrapper.getAttribute('data-lds-product-id') || wrapper.getAttribute('data-product-id') || '');
      if (!config || !wrapperId || config.id === undefined || config.id === null ||
          String(config.id) !== wrapperId || typeof config.sourceUrl !== 'string' ||
          !config.sourceUrl || !validSize(config.sourceSize) ||
          !positiveNumber(config.sourceSize[0]) || !positiveNumber(config.sourceSize[1])) return null;
      if (config.maskUrl && (typeof config.maskUrl !== 'string' ||
          !validSize(config.maskSize) || !validRect(config.bbox))) return null;
      config.id = String(config.id);
      // Exact-product gallery artwork, image 39782933692573; one residual binding.
      // Preserve all other product sources, exclusions, masks and modes.
      if (config.id === '8641639153821' && /lds-white-master-3ad9dcd491322a5614e82423\.png/.test(config.sourceUrl)) {
        config.sourceUrl = config.sourceUrl.replace(/lds-white-master-3ad9dcd491322a5614e82423\.png(?:\?.*)?$/, 'lds-six-hellcat-body-7cddbef1710f13df.png');
        config.maskUrl = config.sourceUrl.replace('lds-six-hellcat-body-7cddbef1710f13df.png', 'lds-six-hellcat-mask-af73956902ee2946.png');
        config.sourceSize = [1280, 790];
        config.maskSize = [1280, 790];
        config.bbox = [0, 0, 1280, 790];
        config.sourceCrop = [0, 0, 1280, 790];
        config.exactRaster = true;
        config.whiteMaskOverlay = false;
        config.neutralizeEmission = false;
        config.sourceLumaTint = false;
        delete config.sourceClip;
      }

      var reviewedClip = fullReviewClips[config.sourceUrl.split("/").pop().split("?")[0]];
      if (reviewedClip) config.sourceClip = reviewedClip;
      // This X5 emission mask includes the halo: retain source luminance rather
      // than painting its binary coverage opaque white. Flow keeps falloff.
      if (config.id === '8642609348765' || /lds-stainless-prepared-master-(2ee975742c68b06583188a49|21f39a5ec1dd07fc3d227d4e)/.test(config.sourceUrl)) config.sourceLumaTint = true;
      return { config: config, node: node };
    } catch (error) {
      if (window.console && console.warn) console.warn('[lds-cover] invalid per-card config', error);
      return null;
    }
  }

  function clearStates() {
    Array.from(states).forEach(removeState);
  }

  function bind(root) {
    if (!onStainlessCollectionPath()) {
      clearStates();
      return;
    }
    if (!root || !root.querySelectorAll) return;
    states.forEach(function (state) {
      if (!state.card.isConnected || !state.configNode.isConnected || !state.wrapper.contains(state.configNode) ||
          state.configText !== (state.configNode.textContent || '')) removeState(state);
    });
    configuredWrappers(root).forEach(function (wrapper) {
      var parsed = configFor(wrapper);
      if (!parsed) return;
      var parts = cardFor(wrapper);
      if (!parts) return;
      var existing = stateByCard.get(parts.card);
      if (existing) {
        if (existing.configNode !== parsed.node || existing.configText !== (parsed.node.textContent || '')) {
          removeState(existing);
        } else {
          return;
        }
      }
      makeState(wrapper, parts.card, parts.media, parts.link, parsed.config, parsed.node);
    });
  }

  function queueBind(root) {
    if (!root || !root.querySelector) return;
    if (bindTimers.has(root)) return;
    var timer = window.setTimeout(function () {
      bindTimers.delete(root);
      bind(root);
    }, 0);
    bindTimers.set(root, timer);
  }

  function runtimeOnlyNode(node) {
    return node && node.nodeType === 1 && (
      node.matches('[data-lds-stainless-cover-canvas]') ||
      node.closest('[data-lds-stainless-cover-card]')
    );
  }

  function relevantMutationNode(node) {
    if (!node) return false;
    if (node.nodeType === 3) return !!node.parentElement && !!node.parentElement.closest(CONFIG_SELECTOR);
    if (node.nodeType !== 1) return false;
    if (runtimeOnlyNode(node)) return node.matches('[data-lds-product-id]') || node.matches('[data-product-id]');
    return node.matches('[data-lds-product-id]') || node.matches('[data-product-id]') || node.matches(CONFIG_SELECTOR) ||
      !!node.querySelector(CONFIG_SELECTOR) || !!node.querySelector('hdt-card-product[data-lds-product-id]');
  }

  function observeDocument() {
    if (documentObserver || typeof MutationObserver !== 'function' || !document.documentElement) return;
    documentObserver = new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        if (record.type === 'characterData') return !!record.target.parentElement &&
          !!record.target.parentElement.closest(CONFIG_SELECTOR);
        if (record.type === 'attributes') return record.target.matches('[data-lds-product-id]') || record.target.matches('[data-product-id]');
        var nodes = Array.prototype.slice.call(record.addedNodes).concat(Array.prototype.slice.call(record.removedNodes));
        return nodes.some(relevantMutationNode);
      });
      if (changed) queueBind(document);
    });
    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-lds-product-id', 'data-product-id']
    });
  }

  function bindAfterPilotUpdate(event) {
    var target = event && event.target;
    if (!target || !target.querySelector) return;
    window.queueMicrotask ? window.queueMicrotask(function () { bind(target); }) : queueBind(target);
  }

  function capabilityChanged() {
    if (!fineHoverEnabled()) {
      Array.from(states).forEach(stopFlow);
      return;
    }
    states.forEach(function (state) {
      if (state.hovered) {
        loadState(state).then(function () { if (state.hovered) startFlow(state); }).catch(function () {});
      }
    });
  }

  function watchMediaQuery(query) {
    if (!query) return;
    if (query.addEventListener) query.addEventListener('change', capabilityChanged);
    else if (query.addListener) query.addListener(capabilityChanged);
  }

  window.__LDS_STAINLESS_COVERS__ = function () {
    return Array.from(states).map(function (state) {
      return {
        id: String(state.config.id),
        ready: !!state.ready,
        active: !!state.active,
        raf: !!state.raf,
        frames: Number(state.frames || 0),
        visible: !!state.visible,
        hovered: !!state.hovered,
        sourceRequested: !!state.sourceRequested,
        maskRequested: !!state.maskRequested
      };
    });
  };

  function start() {
    if (started) return;
    started = true;
    hoverQuery = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
    reducedQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    watchMediaQuery(hoverQuery);
    watchMediaQuery(reducedQuery);
    intersectionObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = Array.from(states).find(function (candidate) { return candidate.media === entry.target; });
        if (!state) return;
        state.visible = !!entry.isIntersecting;
        if (state.visible) {
          loadState(state).catch(function () {});
        } else {
          stopFlow(state);
        }
      });
    }, { rootMargin: '400px 0px' }) : null;
    observeDocument();
    document.addEventListener('pilot:updated', bindAfterPilotUpdate);
    window.addEventListener('popstate', function () { bind(document); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') Array.from(states).forEach(stopFlow);
      else capabilityChanged();
    });
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
